import Editor from './base/editor';
import BlockAlignment from './mixins/block-alignment';
import { alias } from '@ember/object/computed';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Editor.extend(BlockAlignment, {
  width: 126,
  height: 35,
  keysToTriggerClose: [13, 27],
  keepSelectedOnDismiss: true,
  classNames: ['is-light-theme', 'composer-button-editor'],
  classNameBindings: ['isEditMode:composer-editor-is-active'],
  hasTextAndLink: alias('editableObject.hasTextAndLink'),
  init() {
    this._super(...arguments);
    if (!this.get('editableObject.hasTextAndLink')) {
      this.set('isEditMode', true);
      this.set('autoFocusSelector', 'input:first');
    }
  },
  dimensionsChanged: Em.observer({
    dependentKeys: ['isEditMode'],
    fn() {
      schedule('afterRender', this, this.setupEditorDimensions);
    },
    sync: true
  }),
  flushChanges: Em.observer({
    dependentKeys: ['editableObject.text'],
    fn() {
      if (this.triggerDomUpdate) {
        this.triggerDomUpdate();
      }
    },
    sync: true
  }),
  actions: {
    edit() {
      this.set('isEditMode', true);
    },
    dismiss() {
      this.set('isEditMode', false);
      this.cleanData();
    }
  }
});